import { useRouter } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { useState } from "react";
import { TimeEntryForm } from "@/components/time-entries/TimeEntryForm";
import { useWeeklySummary } from "@/hooks/use-time-entries";

function getCurrentWeekMonday() {
  const today = new Date();
  const dow = today.getDay();
  const monOffset = dow === 0 ? -6 : 1 - dow;
  const mon = new Date(today);
  mon.setDate(today.getDate() + monOffset);
  return mon.toISOString().slice(0, 10);
}

export function LogTimePage() {
  const router = useRouter();
  const editId = new URLSearchParams(window.location.search).get("edit");
  const week = getCurrentWeekMonday();
  const { data: summary } = useWeeklySummary(week);
  const [resetKey, setResetKey] = useState(0);

  const editing = editId ? (summary?.entries.find((e) => e.id === editId) ?? null) : null;

  function handleCancel() {
    router.navigate({ to: "/dashboard" });
  }

  function handleSaved(addAnother: boolean) {
    if (addAnother) {
      setResetKey((k) => k + 1);
    } else {
      router.navigate({ to: "/dashboard" });
    }
  }

  const isFlagged = editing?.status === "flagged";
  const isEdit = !!editing;
  const crumbTitle = isFlagged ? "Resolve Flagged" : isEdit ? "Edit Entry" : "New Entry";

  return (
    <>
      <div className="topbar">
        <div className="topbar__crumbs">
          <span>Engineering</span>
          <ChevronRight size={14} />
          <span>Log Time</span>
          {(isEdit || isFlagged) && (
            <>
              <ChevronRight size={14} />
              <strong>{crumbTitle}</strong>
            </>
          )}
          {!isEdit && <strong>New Entry</strong>}
        </div>
        <div className="topbar__actions">
          <span className="t-small t-muted">All times in your local timezone</span>
        </div>
      </div>

      <div className="page">
        <TimeEntryForm
          key={editId ?? `new-${resetKey}`}
          editing={editing ?? null}
          onCancel={handleCancel}
          onSaved={handleSaved}
        />
      </div>
    </>
  );
}
